export default __webpack_public_path__ + "static/profile_miyagawa-695235d1934b9327389169e75276d628.png";